import axiosInstance from "../config/API";
const API_ENDPOINT = "/invoice.php";

// Fetch all invoices (new)
export const fetchInvoiceApi = async () => {
  const payload = {
    action: "listInvoice",
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch all invoices:", response.data.body.invoices);
  return response.data.body.invoices;
};

// Fetch grouped invoices by agent
export const fetchGroupedInvoicesApi = async () => {
  const payload = {
    action: "listGroupedInvoices",
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch grouped invoices:", response.data.body.groupedInvoices);
  return response.data.body.groupedInvoices;
};

// Fetch invoices by agent name
export const fetchInvoicesByAgentApi = async (agentName) => {
  const payload = {
    action: "listInvoicesByAgent",
    agent_name: agentName,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch invoices by agent:", response.data.body.invoices);
  return response.data.body.invoices;
};

// Add a new user
export const addInvoiceApi = async (invoiceData) => {
  console.log("invoicdataapi", invoiceData);
  const payload = {
    action: "createInvoice",
    customer_name: invoiceData.customerDetails.customer_name,
    state: invoiceData.customerDetails.state,
    city: invoiceData.customerDetails.city,
    mobile_number: invoiceData.customerDetails.mobile_number,
    reference_number: invoiceData.customerDetails.reference_number,
    agent_id: invoiceData.customerDetails.agent_id,
    transport_name: invoiceData.customerDetails.transport_name,
    invoice_date: invoiceData.customerDetails.invoice_date,
    products: invoiceData.products,
    overall_total:
      invoiceData.discount !== 0
        ? invoiceData.totals.discountedTotal
        : invoiceData.totals.overallTotal,
    discount: invoiceData.discount,
    tax: invoiceData.totals.taxAmount,
    grand_total: invoiceData.totals.grandTotal,
    bill_created_by: "GURULAKSHMI FIREWORKS",
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("add invoice :", response.data);
  return response.data.body.invoices;
};

// Update a user by ID
export const updateInvoiceApi = async (invoiceData) => {
  console.log(invoiceData, "inv");
  const payload = {
    action: "updateinvoice",
    invoice_id: invoiceData.id,
    customer_name: invoiceData.customerDetails.customer_name,
    state: invoiceData.customerDetails.state,
    city: invoiceData.customerDetails.city,
    mobile_number: invoiceData.customerDetails.mobile_number,
    reference_number: invoiceData.customerDetails.reference_number,
    agent_id: invoiceData.customerDetails.agent_id,
    transport_name: invoiceData.customerDetails.transport_name,
    invoice_date: invoiceData.customerDetails.invoice_date,
    products: invoiceData.products,
    overall_total:
      invoiceData.discount !== 0
        ? invoiceData.totals.discountedTotal
        : invoiceData.totals.overallTotal,
    discount: invoiceData.discount,
    tax: invoiceData.totals.taxAmount,
    grand_total: invoiceData.totals.grandTotal,
    bill_created_by: "GURULAKSHMI FIREWORKS",
  };
  const response = await axiosInstance.post(`${API_ENDPOINT}`, payload);
  console.log("update response", response.data);
  return response.data.body.invoices;
};

// Delete a user by ID
export const deleteInvoiceApi = async (id) => {
  const payload = {
    action: "deleteinvoice",
    invoice_id: id,
  };
  const response = await axiosInstance.post(`${API_ENDPOINT}`, payload);
  return id; // Return the user ID for successful deletion
};
